import React from 'react';
import Panel from '../Site/Panel';
import { Form } from 'react-bootstrap';

const InGameSettings = ({ formProps }) => {
    return (
        <Panel title='Game Settings'>
            <Form.Check
                id='confirmOneClick'
                name='gameOptions.confirmOneClick'
                label='Show a prompt when initating 1-click abilities'
                // type='switch'
                checked={formProps.values.gameOptions.confirmOneClick}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
            />
            <Form.Check
                id='allowAutoCancel'
                name='gameOptions.allowAutoCancel'
                label="Allow card switching without pressing 'Cancel' button"
                // type='switch'
                checked={formProps.values.gameOptions.allowAutoCancel}
                onChange={formProps.handleChange}
                onBlur={formProps.handleBlur}
            />
        </Panel>
    );
};

export default InGameSettings;
